import { goto } from '$app/navigation';
import { fetchApiKit } from 'Services/fetchApiKit';
import { writable } from 'svelte/store';

export const initMobileApp = () => {
	//  this will allow js injection to use sveltekit front routing
	//  for mobile navigation
	window.goto = (url) => {
		goto(url);
	};

	// capture errors globally
	window.onerror = (event, source, lineno, colno, error) => {
		console.log('window.onerror', event, source, lineno, colno, error);
		backofficeError();
	};

	//capture errors on initial render
	window.onunhandledrejection = (event) => {
		console.log('window.onunhandledrejection', event);
		backofficeError();
	};

	loadingStarted();
};

// it may seem redundant to declare them all here, but it's easier to see what's available on the flutter side
export const loadingStarted = () => {
	showMobileAppLoadingScreen.set(true);
	console.log('calling flutter handler loadingStarted');
	window?.flutter_inappwebview?.callHandler('loadingStarted');
};

export const loadingFinished = () => {
	console.log('calling flutter handler loadingFinished');
	window?.flutter_inappwebview?.callHandler('loadingFinished');
};

export const backofficeError = () => {
	console.log('calling flutter handler backofficeError');
	window?.flutter_inappwebview?.callHandler('backofficeError');
};

export const sendNotification = (title, body = '') => {
	console.log('calling flutter handler notify');
	if (title?.length > 0 && body?.length > 0)
		window?.flutter_inappwebview?.callHandler('notify', title, body);
	else throw new Error('notify requires title and body');
};

export const downloadFileFromServer = (args) => {
	console.log('calling flutter downloadFileFromServer handler');
	window.flutter_inappwebview.callHandler('downloadFileFromServer', args);
	handleEndDownload(args.onDownloadEnd);
};

export const downloadFileFromEndpoint = (args) => {
	console.log('calling flutter downloadFileFromEndpoint handler');
	window.flutter_inappwebview.callHandler('downloadFileFromEndpoint', args);
	handleEndDownload(args.onDownloadEnd);
};

export const logout = () => {
	console.log('calling flutter logout handler');
	window.flutter_inappwebview.callHandler('logout', 1);
};

export const changeRestaurant = (args) => {
	console.log('calling flutter changeRestaurant handler');
	window.flutter_inappwebview.callHandler('changeRestaurant', args);
};

export const changeWebviewState = (args) => {
	console.log('calling flutter changeWebviewState handler');
	window.flutter_inappwebview.callHandler('changeWebviewState', args);
};

export const getWebviewState = () => {
	console.log('calling flutter getWebviewState handler');
	return window.flutter_inappwebview.callHandler('getWebviewState');
};

export const downloadFileGenerated = async (args) => {
	console.log('calling flutter downloadFileFromServer handler (with generated file)');
	let path;
	//remove to download on ios
	let filename = args.filename.replace(/ /g, '_');
	try {
		const response = await fetchApiKit({
			route: '/pdf/writeForMobile',
			method: 'POST',
			body: JSON.stringify({
				html: args.content,
				folder: args.folder,
				isLegacy: args.isLegacy,
				filename: filename,
				createFolder: true
			}),
			headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
		});
		path = response.path;
	} catch (error) {
		console.error(error);
	}
	downloadFileFromServer({
		filename: filename,
		path,
		folder: args.folder
	});
	handleEndDownload(args.onDownloadEnd);
};

const handleEndDownload = (onDownloadEnd) => {
	if (onDownloadEnd) {
		window.downloaded = onDownloadEnd;
	} else {
		window.downloaded = () => {};
	}
};

/**
 * @returns {{ token: string; name: string; operatingSystem: string; }}
 */
export const getDeviceInfos = () => {
	let interval;
	return new Promise((resolve, reject) => {
		interval = setInterval(async () => {
			const deviceInfos = await window?.flutter_inappwebview?.callHandler('getDeviceInfos');
			if (deviceInfos) {
				clearInterval(interval);
				resolve(deviceInfos);
			}
		}, 500);
	});
};

export const showMobileAppLoadingScreen = writable(false);
